import Component from 'vue-class-component';

// register Vue Router hooks
Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave'
]);
